export default function NoResults({ query }) {
    return (
        <div className="aa-PanelLayout">
            <div className="d-flex flex-column justify-content-center align-items-center text-center p-4">
                <svg viewBox="0 0 20 20" fill="none" width="40" height="40" className="stroke-current text-muted">
                    <path d="M15.5 4.8c2 3 1.7 7-1 9.7h0l4.3 4.3-4.3-4.3a7.8 7.8 0 01-9.8 1m-2.2-2.2A7.8 7.8 0 0113.2 2.4M2 18L18 2" />
                </svg>
                <h2 className="mt-4 display-4">
                    No results for <strong>&ldquo;{query}&rdquo;</strong>.
                </h2>
            </div>
        </div>
    )
}
